<p-checkbox #inputField [disabled]="disabled" [(ngModel)]="checked" binary="true"></p-checkbox>
